import React, { useState } from "react";
import "./dashboard.css"; // reuse your dashboard styling

function MakeIntegration() {
  const [webhookUrl, setWebhookUrl] = useState("");
  const [status, setStatus] = useState("Not Connected");

  const generateWebhook = () => {
    const url = `https://hook.eu1.make.com/${Math.random().toString(36).substring(2, 12)}`;
    setWebhookUrl(url);
    setStatus("Connected");
  };

  return (
    <div className="page-container">
      <h2 className="page-title">Make.com Integration</h2>

      <div className="card">
        <h3>Automation Setup</h3>
        <p className="subtext">
          Connect your dashboard to Make.com to automate tasks, send events, and
          build workflows.
        </p>

        <button className="primary-btn" onClick={generateWebhook}>
          Generate Webhook URL
        </button>

        {webhookUrl && (
          <div className="webhook-box">
            <p>Your webhook URL:</p>
            <code>{webhookUrl}</code>
          </div>
        )}

        <div className="integration-status">
          <h4>Status:</h4>
          <span className={status === "Connected" ? "connected" : "disconnected"}>
            {status}
          </span>
        </div>
      </div>

      <div className="card">
        <h3>Connected Workflows</h3>
        <ul className="workflow-list">
          <li>New Wallet Added → Send email notification</li>
          <li>New Transaction → Update Google Sheets</li>
          <li>Activity Heatmap → Sync daily stats</li>
        </ul>
      </div>
    </div>
  );
}

export default MakeIntegration;
